import React from "react";
import { Navigate } from "react-router-dom";

const RequireSuperAdmin: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const userData = localStorage.getItem("user");
  let isSuperAdmin = false;
  if (userData) {
    try {
      const parsedUserData = JSON.parse(userData);
      isSuperAdmin = parsedUserData.is_super_admin;
    } catch {}
  }

  if (!isSuperAdmin) {
    // Redirect to a "not authorized" page or home
    return <Navigate to="/admin/orders" replace />;
  }

  return <>{children}</>;
};

export default RequireSuperAdmin;